import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BottomSection, Gallery, MainColumn, Sections, TopBar, } from "@/components";
import { Breadcrumb } from "@/components/Breadcrumb";
import { ContactCardColumn, StickyCta } from "@/components/contacting";
import { FeedbackSurvey } from "@/components/FeedbackSurvey";
import { SimilarListingCSR } from "@/components/SimilarListings/SimilarListingCSR";
import { useIsLandscape } from "@/hooks";
import { useBreakpointValue } from "@gemini/core";
import { CdpMobileViewCss } from "./CdpTemplatesCss";
export const TemplateDefault = () => {
    const isMobile = useBreakpointValue({
        base: true,
        lg: false,
    });
    const isLandscape = useIsLandscape();
    return (_jsxs(_Fragment, { children: [(isMobile || isLandscape) && _jsx(CdpMobileViewCss, {}), _jsx(TopBar, {}), _jsxs(MainColumn, { children: [_jsx(Gallery, {}), _jsx(Sections, {})] }), _jsx(ContactCardColumn, {}), _jsx(SimilarListingCSR, {}), _jsx(BottomSection, {}), _jsx(FeedbackSurvey, {}), _jsx(Breadcrumb, {}), _jsx(StickyCta, { tracking: { avZone: "sticky" }, position: "onScroll" })] }));
};
